// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".GenericPage[data-v-67be2b52]{min-height:100vh}.GenericPage__body[data-v-67be2b52]{min-height:calc(100vh - 10vw)}\n", ""]);
// Exports
module.exports = exports;
